export default "#preImport <isotropyLightCompute>\n#preImport <anisotropyLightCompute>";